import { finish, error } from '../../../modules/customers/actions/create';

import api from '../../../api';

export function request(dispatch, { data }) {
    api.post('/customers', data).then(
        (customer) => dispatch(finish(customer)),
        ({ errors, debug }) => dispatch(error(errors, debug))
    );
}
